import { render, staticRenderFns } from "./ProjectShowComponent.vue?vue&type=template&id=2e94a78f&scoped=true"
import script from "./ProjectShowComponent.vue?vue&type=script&lang=js"
export * from "./ProjectShowComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectShowComponent.vue?vue&type=style&index=0&id=2e94a78f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94a78f",
  null
  
)

export default component.exports